import { atom } from 'jotai';
import mapStyleConfig from './assets/mapStyleConfig.json';
import { anyType, fiwareDataItemType, dataLoadedResultType, nonLngLatDataType, mapType } from './types';
import { ShareInfoType } from './types/components/shareBox';
import { DataType, MenuSectionType, ThemeMapType } from './types/lib/types';
import { MapStyleConfigType } from './types/components/mapStyleConfig';
import { MAIN_MAP_ID } from './constants/components/map';
import { TileUrlInfo } from './types/lib/useGetTileUrls';

const initialBaseMap = mapStyleConfig[0];

export enum ViewState {
    FirstView = 'firstview',
    FirstClosed = 'firstclosed',
    SubsequentView = 'subsequentview',
    Closed = 'closed'
}


export const clickLngLatAtom = atom<[number, number] | undefined>(undefined);              // クリックした緯度経度

// fiwareデータ
export const fiwareDataAtom = atom<{[key: string]: anyType} | undefined>(undefined);
// fiwareのカタログデータ
export const fiwareCatalogDataItemsAtom = atom<fiwareDataItemType[] | undefined>(undefined);
// fiwareの凡例
export const legendTableAtom = atom<{[key: string]: anyType} | undefined>(undefined);
// fiwareのデータ取得状況
export const fiwareFetchStatusesAtom = atom<{ [key: string]: boolean }>({});

export const gyoseikaiObjAtom = atom<DataType | undefined>(undefined);                   // 行政区オブジェクト

export const menuItemsAtom = atom<DataType[] | undefined>(undefined);                       // メニュー情報

export const dataLoadedResultAtom = atom<dataLoadedResultType>('loading');                  // データ読み込み完了フラグ

// エンドポイント
export const fiwareEndpointAtom = atom<{ [key: string]: string; } | undefined | undefined>(undefined);

export const printAttributionsAtom = atom<{ [key: string]: string; }[] | undefined>(undefined);                             // 出力用出展ソース

// --- map毎のselectedLayers ---
export const selectedSubMapLayersAtom = atom<string[] | undefined>(undefined);
export const selectedLayersAtom = atom<string[] | undefined>(undefined);

// --- マップクリックイベント ---
export const mapClickEventAtom = atom<maplibregl.MapMouseEvent | undefined>(undefined);
export const leftMapClickEventAtom = atom<maplibregl.MapMouseEvent | undefined>(undefined);

// --- エラー ---
export const dataErrorMessageAtom = atom<string[] | undefined>(undefined);
export const leftMapDataErrorMessageAtom = atom<string[] | undefined>(undefined);

// --- 非緯度経度データ ---
export const nonLngLatDataArrAtom = atom<nonLngLatDataType[] | undefined>(undefined);
export const leftMapNonLngLatDataArrAtom = atom<nonLngLatDataType[] | undefined>(undefined);


export const tileDatasAtom = atom<TileUrlInfo[] | undefined>(undefined);              // app.ymlから取得したソース名を保持

export const bgMapSourcesAtom = atom<MapStyleConfigType[]>([]);                                // 背景地図のソース名

// ----- map関係 -----
export const mainMapAtom = atom<maplibregl.Map | null>(null);                        // メインマップ
export const subMapAtom = atom<maplibregl.Map | null>(null);                         // サブマップ
export const selectedBaseMapAtom = atom<MapStyleConfigType| undefined>(initialBaseMap as MapStyleConfigType);
export const selectedBaseMapLeftAtom = atom<MapStyleConfigType| undefined>(initialBaseMap as MapStyleConfigType);

export const searchResultLngLatAtom = atom<[number, number] | undefined>(undefined);  // 検索結果の緯度経度

export const selectedMapIdAtom = atom<mapType>(MAIN_MAP_ID);                         // 選択中の地図Id

export const isFirstViewAtom = atom<boolean>(true);                                 // URLパラメータのレイヤー情報

export const menuAtom = atom<MenuSectionType | undefined>(undefined);                // メニュー情報

export const secondMapObjAtom = atom<maplibregl.Map | null>(null);

export const selectedFeatureAtom = atom<{[key: string]: maplibregl.MapGeoJSONFeature[]} | undefined>(undefined);  // 選択中のfeature（印刷・画像出力用）

export const imgUrlAtom = atom<string | undefined>(undefined);                                      // 画像URL

export const sidebarHeightAtom = atom<'full' | 'half' | 'close'>('close');               // サイドバー表示(スマホ)
export const isSidebarOpenAtom = atom<boolean>(true);                                               // サイドバー表示(PC)

export const tOSViewStateAtom = atom<ViewState>(ViewState.FirstView);                                  // 利用規約表示

// ------ 機能関連 ------（地図別）
export const isDrawControlOpenAtom = atom<mapType | undefined>(undefined);                      // 描画
export const isDistanceControlOpenAtom = atom<mapType | undefined>(undefined);                  // 距離測定
export const isAreaCalcControlOpenAtom = atom<mapType | undefined>(undefined);                  // 面積測定
export const isCenterMarkControlOpenAtom = atom<boolean>(false);                                // 中心マーク表示
export const isIndexMapOpenAtom = atom<boolean>(false);                                         // 索引図表示
export const isLeftCenterMarkControlOpenAtom = atom<boolean>(false);                            // 中心マーク表示（左地図）
export const isLeftIndexMapOpenAtom = atom<boolean>(false);                                     // 索引図表示（左地図）
// ------ 機能関連 ------（両地図）
export const isPrinterControlOpenAtom = atom<boolean>(false);                                   // 印刷
export const isDownloadControlerOpenAtom = atom<boolean>(false);                                // 画像書き出しの設定
export const isSeparateDisplayControllerAtom = atom<boolean>(false);                            // 2画面表示
export const isTerrainControlerOpenAtom = atom<boolean>(false);                                 // 3D表示

export const isLegendControlOpenAtom = atom<boolean>(false);                    // 凡例表示
export const shareInfoAtom = atom<ShareInfoType | undefined>(undefined);        // シェア情報

export const initialCenterAtom = atom<[number, number] | undefined>(undefined);
export const initialZoomAtom = atom<number | undefined>(undefined);
export const initialPitchAtom = atom<number | undefined>(undefined);

export const isDesktopAtom = atom<boolean>(false);

export const selectedThemeMapAtom = atom<ThemeMapType|null>(null);

export const geoloniaBrokerStageAtom = atom<'v1' | 'dev'>('v1');
